<div class="idd-training-details-view-container" *ngIf="iddTrainingObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="id-info">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="iddTrainingObject.recordId?.toString()">
    </mat-form-field>
  </div>

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + iddTrainingObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="iddTrainingObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="iddTrainingObject.certificates.length === 0" (click)="downloadZip()" mat-stroked-button color="accent"><mat-icon>download</mat-icon> <span> Pobierz zaświadczenia</span></button>
    <button [disabled]="!(userPermissions | async).idd_training.write || iddTrainingObject.status.key === IDD_TRAINING_STATUS_NOT_APPLICABLE" (click)="changeToNotApplicable()" mat-stroked-button color="warn"><mat-icon>person_off</mat-icon> <span> Anuluj szkolenie IDD</span></button>
    <button [disabled]="!(userPermissions | async).idd_training.write || iddTrainingObject.status.key === IDD_TRAINING_STATUS_NOT_APPLICABLE" (click)="addStatement()" mat-stroked-button color="primary"><mat-icon>description</mat-icon> <span> Dodaj oświadczenie</span></button>
    <button *ngIf="(userPermissions | async).idd_training.admin_root" [disabled]="!(userPermissions | async).idd_training.admin_root " (click)="refresh()" mat-icon-button matTooltip="Odświerz wymogi" ><mat-icon>refresh</mat-icon> </button>

  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane szkolenia IDD</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Nazwa">
                IDD {{iddTrainingObject.year}} {{iddTrainingObject.ofwca.fullName}}
              </app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Postęp">
                <app-idd-training-chart
                  [iddTraining]="iddTrainingObject"
                  [chartType]="chartType"
                  style="height: 40px;
                  width: 100%;
                  display: block"
                ></app-idd-training-chart>
              </app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Dni do końca roku" [value]="daysToEndOfYear.toString()"></app-detail>
            </div>

            <ng-container >
              <div fxLayout="row" fxLayoutGap="15px">
                <app-detail
                  fxFlex="30"
                  header="Do zrealizowania - majątek"
                >
                  {{floor(iddTrainingObject.requiredAssetsMinutes / 60).toString() | number:'1.0-0'}}h
                  {{floor(iddTrainingObject.requiredAssetsMinutes % 60).toString() | number:'1.0-0'}}min
                </app-detail>

                <app-detail
                  fxFlex="30"
                  header="Do zrealizowania - życie"
                >
                  {{floor(iddTrainingObject.requiredLifeMinutes / 60).toString() | number:'1.0-0'}}h
                  {{floor(iddTrainingObject.requiredLifeMinutes % 60).toString() | number:'1.0-0'}}min
                </app-detail>

                <app-detail
                  fxFlex="30"
                  header="Do zrealizowania - ogólne"
                >
                  {{floor(iddTrainingObject.requiredGeneralMinutes / 60).toString() | number:'1.0-0'}}h
                  {{floor(iddTrainingObject.requiredGeneralMinutes % 60).toString() | number:'1.0-0'}}min
                </app-detail>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <app-detail
                  fxFlex="30"
                  header="Zrealizowane - majątek"
                >
                  {{floor(iddTrainingObject.realisedAssetsMinutes / 60).toString() | number:'1.0-0'}}h
                  {{floor(iddTrainingObject.realisedAssetsMinutes % 60).toString() | number:'1.0-0'}}min
                </app-detail>

                <app-detail
                  fxFlex="30"
                  header="Zrealizowane - życie"
                >
                  {{floor(iddTrainingObject.realisedLifeMinutes / 60).toString() | number:'1.0-0'}}h
                  {{floor(iddTrainingObject.realisedLifeMinutes % 60).toString() | number:'1.0-0'}}min
                </app-detail>

                <app-detail
                  fxFlex="30"
                  header="Zrealizowane - ogólne"
                >
                  {{floor(iddTrainingObject.realisedGeneralMinutes / 60).toString() | number:'1.0-0'}}h
                  {{floor(iddTrainingObject.realisedGeneralMinutes % 60).toString() | number:'1.0-0'}}min
                </app-detail>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <app-detail
                  fxFlex="30"
                  header="Pozostało - majątek"
                >
                  {{floor(iddTrainingObject.leftAssetsMinutes / 60).toString() | number:'1.0-0'}}h
                  {{floor(iddTrainingObject.leftAssetsMinutes % 60).toString() | number:'1.0-0'}}min
                </app-detail>

                <app-detail
                  fxFlex="30"
                  header="Pozostało - życie"
                >
                  {{floor(iddTrainingObject.leftLifeMinutes / 60).toString() | number:'1.0-0'}}h
                  {{floor(iddTrainingObject.leftLifeMinutes % 60).toString() | number:'1.0-0'}}min
                </app-detail>

                <app-detail
                  fxFlex="30"
                  header="Pozostało - ogólne"
                >
                  {{floor(iddTrainingObject.leftGeneralMinutes / 60).toString() | number:'1.0-0'}}h
                  {{floor(iddTrainingObject.leftGeneralMinutes % 60).toString() | number:'1.0-0'}}min
                </app-detail>
              </div>
            </ng-container>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="OFWCA" [value]="iddTrainingObject.ofwca?.fullName" [link]="['/ofwca/szczegoly', iddTrainingObject.ofwca?.uuid]"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Partner" [value]="iddTrainingObject.ofwca?.partner?.shortName"
                          [link]="['/partnerzy/szczegoly', iddTrainingObject.ofwca?.partner?.uuid]"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Regionalny (majątek) OFWCA" [value]="iddTrainingObject.ofwca?.assetsRegional?.fullName"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Regionalny (majątek)" [value]="iddTrainingObject.ofwca?.partner?.assetsRegional?.fullName"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="iddTrainingObject.statement">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Oświadczenie</h3>
            </div>

            <div fxLayout="row">
              <app-detail
                fxFlex="100" header="Oświadczenie"
                [value]="iddTrainingObject.statement?.documentName"
                [link]="['/dokumenty/szczegoly', iddTrainingObject.statement?.uuid]"
              ></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail
                fxFlex="100" header="Data wpisu do rejestru pośredników ubezpieczeniowych"
                [value]="iddTrainingObject.dateOfEntryInRau | date:'y-MM-dd'"
              ></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" [style.margin-top]="'15px'">
              <button
                [disabled]="!(userPermissions | async).document.read"
                mat-stroked-button (click)="downloadStatement()"
                color="accent"
              >
                <mat-icon>download</mat-icon> <span> Pobierz oświadczenie</span>
              </button>

              <button
                [disabled]="!(userPermissions | async).document.delete"
                (click)="deleteStatement()" mat-stroked-button color="warn"
              >
                <mat-icon>delete</mat-icon> <span> Usuń oświadczenie</span>
              </button>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

  </div>
</div>
